import React from 'react';
import WebBackground from '@/assets/images/bg-login-web.avif';
import { cn } from '@/utils';

interface UnauthLayoutProps {
	children: React.ReactNode;
	className?: string;
	panelClassName?: string;
	panelStyle?: React.CSSProperties;
}

export function UnauthLayout({
	children,
	className,
	panelClassName,
	panelStyle,
}: UnauthLayoutProps) {
	return (
		<div className={cn('relative w-full h-screen bg-[#151B2E] overflow-hidden', className)}>
			<img
				src={WebBackground}
				className="hidden lg:block absolute inset-0 w-full h-full object-cover"
				alt="background"
			/>
			<div
				className={cn(
					'absolute top-0 right-0 h-full max-h-screen w-full lg:w-[33%] bg-[#151B2E] bg-cover bg-center bg-no-repeat flex items-center justify-center',
					panelClassName
				)}
				style={panelStyle}
			>
				{children}
			</div>
		</div>
	);
}
